// extracted by mini-css-extract-plugin
module.exports = {"header":"MainHeader_header__Wj1Lq","logo":"MainHeader_logo__1Fjij","organization":"MainHeader_organization__QOT0c","divider":"MainHeader_divider__2vFAk"};